import { render, staticRenderFns } from "./cv-column.vue?vue&type=template&id=4c5fa372&"
import script from "./cv-column.vue?vue&type=script&lang=js&"
export * from "./cv-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports